import { compose, withHandlers, withState, lifecycle } from 'recompose';
import moment from 'moment';
import ScheduleRecurringCampaign from '../components/ScheduleRecurringCampaign';
import { getNextGivenWeekdayOfType } from '../helpers';

const ScheduleRecurringCampaignContainer = compose(
  withState('showDateEndPicker', 'setShowDateEndPicker', false),
  withState('showMoreInfo', 'setShowMoreInfo', false),
  withState('recurringDangerSwitch', 'setRecurringDangerSwitch', true),
  withState('frequency', 'setFrequency', '1'),
  withState('time', 'setTime', moment().add(2, 'hour').startOf('hour').format('HH:mm')),
  withState('dayOfWeek', 'setDayOfWeek', moment().format('d')),
  withHandlers({
    validateDateTime: props => (day, time = props.time) => {
      const now = getNextGivenWeekdayOfType(day);
      const dateStr = now.toISOString().split('T').shift();
      const attemptedDateTime = moment(`${dateStr} ${time}`).toDate();

      return (attemptedDateTime >= new Date());
    },
  }),
  withHandlers({
    onSetDayOfWeek: props => (day) => {
      props.setDayOfWeek(day);
      if (props.validateDateTime(day)) {
        props.onDateStartChange(getNextGivenWeekdayOfType(day));
      } else {
        props.onDateStartChange(getNextGivenWeekdayOfType(day).add(1, 'week'));
      }
    },
  }),
  withHandlers({
    onSendToAllCustomersToggle: props => () => {
      props.onRecurringSendToAllCustomers(props.recurringDangerSwitch);
      props.setRecurringDangerSwitch(!props.recurringDangerSwitch);
    },
    onUpdateFrequency: props => (event) => {
      props.setFrequency(event.target.value);
      props.onFrequencyChange(event.target.value);
    },
    onUpdateTime: props => (event) => {
      const time = event.target.value;
      props.setTime(time);
      props.onRecurringTimeChange(time);

      if (!props.validateDateTime(props.dayOfWeek, time)) {
        props.onDateStartChange(getNextGivenWeekdayOfType(props.dayOfWeek).add(1, 'week'));
      } else {
        props.onDateStartChange(getNextGivenWeekdayOfType(props.dayOfWeek));
      }
    },
    onHideEndDatePicker: props => () => {
      props.onDateEndChange(null);
      props.setShowDateEndPicker(false);
    },
    onShowEndDatePicker: props => () => {
      props.onDateEndChange(moment(new Date()).add(1, 'M').format('YYYY-MM-DD'));
      props.setShowDateEndPicker(true);
    },
    onDateStartChangeWithEffect: props => (day) => {
      props.setDayOfWeek(moment(day).format('d'));
      props.onDateStartChange(day);
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.onUpdateTime({ target: { value: this.props.time } });
    },
  })
)(ScheduleRecurringCampaign);

export default ScheduleRecurringCampaignContainer;
